module.exports = __webpack_public_path__ + "img/maintenance-3.62ecd338.png";